import { useEffect, useState } from "react";
import { i18n } from "../../translate/i18n";
import { Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Typography, Grid } from "@mui/material";
import { Button } from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import SingleSelect from "../InputStyled/singleSelect";
import { toast } from "react-toastify";
import CustomStepper from "../General/CustomStepper";
import { makeStyles } from "@material-ui/core/styles";

/*
  MODELO DE OBJETO DO SELECTEDCONNECTIONANDQUEUES
  interface IConnectionAndQueueIds {
    connectionId: number | string,
    originQueueId: number,
    queueId: number,
    userId?: number
  }[];
*/

const useStyles = makeStyles(theme => ({
  userState: {
    padding: '0',
    borderRadius: '100%',
    marginRight: '5px',
    boxShadow: 'box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;background-color: rgb(66, 66, 66)',
    height: '10px',
    width: '10px',
    display: 'inline-block',
  }
}));

const DeleteUserModal = ({
  userId,
  onClose,
  open,
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [connections, setConnections] = useState([]);
  const [connectionsAndQueues, setConnectionsAndQueues] = useState([]);
  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedConnectionsAndQueues, setSelectedConnectionsAndQueues] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  useEffect(() => {
    if (open != true || !userId) return;

    let isMounted = true;
    const abortController = new AbortController();
    setLoading(true);

    (async () => {
      try {

        // resgatar todos os usuários ativos no sistema, e suas relações de conexões e filas
        const { data: usrData } = await api.get("/users/", {
          params: {
            page: 1,
            rowsPerPage: 1000,
            order: "ASC",
            orderBy: "name",
            searchParam: "",
            userStatus: 1,
            completeUsers: 1
          },
          signal: abortController.signal,
        });
        if (!isMounted) {
          setLoading(false);
          return;
        }
        if (usrData?.users) setUsers(usrData.users);

        // resgatar conexões de todos os atendimentos que o usuário tem
        const { data: dataConn } = await api.get(`/user/disable/getTransferOptions/${userId}`, {
          signal: abortController.signal,
        });

        if (!isMounted) {
          setLoading(false);
          return;
        }
        if (Array.isArray(dataConn?.connections) && Array.isArray(dataConn?.connectionsAndQueues)) {
          setConnections(dataConn.connections);
          setConnectionsAndQueues(dataConn.connectionsAndQueues);
          setSteps(dataConn.connections.map((con, index) => `${index + 1}°`));

          // deixar filas atuais selecionadas
          for (const connections of dataConn.connectionsAndQueues) {
            for (const que of connections.queueIds) {
              setSelectedConnectionsAndQueues(prev => {
                // identificar item
                const idx = prev.findIndex(item => item.connectionId == connections.connectionId && item.originQueueId == que);
                if (idx == -1) { return [...prev, { connectionId: connections.connectionId, originQueueId: que, queueId: que, userId: undefined }]; }
                else { return prev.map(item => item.connectionId == connections.connectionId && item.originQueueId == que ? { connectionId: connections.connectionId, originQueueId: que, queueId: que, userId: undefined } : item); }
              });

              // filtrar os usuários da conexão e fila
              setSelectedUsers(prev => {
                const idx = prev.findIndex(
                  item => item.connectionId == connections.connectionId && item.queueId == que
                );

                const usersTmp = [];
                if (Array.isArray(usrData.users)) {
                  usrData.users.filter(u => {
                    const uIdx = u?.connectionsAndQueues?.findIndex(caq => caq.connectionId == connections.connectionId);
                    if (uIdx == -1) return false;

                    return u.connectionsAndQueues[uIdx]?.queueIds.includes(que) == true ? true : false;
                  }).map(u => usersTmp.push(u));
                }

                if (idx== -1) {
                  return [...prev, { connectionId: connections.connectionId, queueId: que, users: usersTmp }];
                }

                return prev.map(item =>
                  item.connectionId == connections.connectionId && item.queueId == que
                    ? { ...item, users: usersTmp }
                    : item
                );
              }); 
            }
          }
        }
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } catch (err) {
        setLoading(false);
        if (!isMounted || err.name == 'AbortError') return;
        console.error({ err });
        toastError(err);
      }
    })();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, [open])

  const handleClose = (event, reason) => {
    if (reason == 'backdropClick') {
      event.preventDefault();
      return;
    }

    setConnections([]);
    setConnectionsAndQueues([]);
    setSelectedConnectionsAndQueues([]);
    setSteps([]);
    setActiveStep(0);
    setUsers([]);
    setSelectedUsers([]);
    onClose();
  };

  const handleSave = () => {

    // se não for o ultimo stepepr, retornar para não salvar ainda
    if (activeStep < (connections.length - 1)) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      return;
    }

    // validação de acordo com o step selecionado
    if (connectionsAndQueues[activeStep]?.queueIds) {
      const conn = connections.find(c => c.id == connectionsAndQueues[activeStep].connectionId);
      for (const q of connectionsAndQueues[activeStep].queueIds) {
        const queue = conn?.Queues?.find(que => que.id == q);
        const queueId = selectedConnectionsAndQueues.find(item => item.connectionId == connectionsAndQueues[activeStep].connectionId && item.originQueueId == q)?.queueId || undefined;
        if (!queueId) {
          toast.error(`${i18n.t("users.disableModal.selectAQueueFor")}: ${conn.name} - ${queue.name}`);
          return;
        }
      }
    }

    (async () => {
      try {
        setLoading(true);
        const { data } = await api.post(`/user/disable/${userId}`, {
          connectionsAndQueues: selectedConnectionsAndQueues
        });
        setLoading(false);
        handleClose();
      } catch (err) {
        setLoading(false);
        console.error({ err });
        toastError(err);
      }
    })();
  }

  const isOnline = (usr) => {
    let statusColor;
    let key = new Date().getTime();
    let check = usr.state;
    let name = usr.name;

    switch (String(check).toLocaleLowerCase()) {
      case 'online':
        statusColor = '#4caf50';
        break;
      case 'out':
        statusColor = '#ff9800';
        break;
      default:
        statusColor = '#f44336';
        break;
    }

    return (
      <>
        <Typography
          component="span"
          key={key}
          className={classes.userState}
          style={{ background: statusColor }}
        />
        {name}
      </>
    );
  }

  const renderUserOptions = (connectionId, originQueueId) => {
		const response = [];
		if (connectionId, originQueueId) {
      const idx = selectedUsers.findIndex(item => item.connectionId == connectionId && item.queueId == originQueueId);
      if (idx > -1 && selectedUsers[idx] && Array.isArray(selectedUsers[idx]?.users)) {
        selectedUsers[idx].users.map((u) => {
          response.push({
            key: u.id,
            value: u.name,
            customValue: isOnline(u),
            disabled: false
          });
        });
      }
		}
		return response;
	}

  return (
    <Dialog
      open={open == true ? true : false}
      onClose={(event, reason) => handleClose(event, reason)}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      disableEscapeKeyDown={true}
      disableAutoFocus 
      disableEnforceFocus
    >
      <DialogTitle id="form-dialog-title">{i18n.t("users.disableModal.title")}</DialogTitle>
      <DialogContent dividers>
        {
          (Array.isArray(connections) && connections.length > 0)
            ? 
            <>
              <Grid container spacing={2} hidden={steps.length == 1 ? true : false}>
                <Grid item xs={12} mb={2}>
                  <CustomStepper
                    steps={steps}
                    activeStep={activeStep}
                  />
                </Grid>
              </Grid>
              {connectionsAndQueues.map((conn, index) => {
                const con = connections.find(c => c.id == conn.connectionId);
                return conn.queueIds.map(queueId => {
                  const queue = con?.Queues ? con.Queues.find(q => q.id == queueId)?.name : '';
                  return (
                    <>
                      <Grid container spacing={2} hidden={activeStep != index}>
                        <Grid item xs={12} mb={2}>
                          <SingleSelect
                            name={`userTransferQueue-${conn.connectionId}-${queueId}`}
                            key={`userTransferQueue-${conn.connectionId}-${queueId}`}
                            displayText={i18n.t("users.disableModal.selectAQueue")}
                            title={
                              <>
                                <Typography>{`Conexão: ${con.name}`}</Typography>
                                <Typography>{`Fila: ${queue}`}</Typography>
                              </>
                            }
                            options={con?.Queues?.length > 0 ? con.Queues.map(q => { return { key: q.id, value: q.name, disabled: false } }) : []}
                            disabled={false}
                            closeOnSelect={true}
                            selected={selectedConnectionsAndQueues.find(item => item.connectionId == conn.connectionId && item.originQueueId == queueId)?.queueId || undefined}
                            onSelected={(qId) => {
                              setSelectedConnectionsAndQueues(prev => {
                                // identificar item
                                const idx = prev.findIndex(item => item.connectionId == conn.connectionId && item.originQueueId == queueId);
                                if (idx == -1) { return [...prev, { connectionId: conn.connectionId, originQueueId: queueId, queueId: qId, userId: undefined }]; }
                                else { return prev.map(item => item.connectionId == conn.connectionId && item.originQueueId == queueId ? { connectionId: conn.connectionId, originQueueId: queueId, queueId: qId, userId: undefined } : item); }
                              });

                              // filtrar os usuários da conexão e fila
                              setSelectedUsers(prev => {
                                const idx = prev.findIndex(
                                  item => item.connectionId == conn.connectionId && item.queueId == queueId
                                );
                              
                                const usersTmp = [];
                                if (Array.isArray(users)) {
                                  users.filter(u => {
                                    const uIdx = u?.connectionsAndQueues?.findIndex(caq => caq.connectionId == conn.connectionId);
                                    if (uIdx == -1) return false;

                                    return u.connectionsAndQueues[uIdx]?.queueIds.includes(qId) == true ? true : false;
                                  }).map(u => usersTmp.push(u));
                                }
                              
                                if (idx == -1) {
                                  return [...prev, { connectionId: conn.connectionId, queueId, users: usersTmp }];
                                }
                              
                                return prev.map(item =>
                                  item.connectionId == conn.connectionId && item.queueId == queueId
                                    ? { ...item, users: usersTmp }
                                    : item
                                );
                              });                              
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} hidden={activeStep != index}>
                        <Grid item xs={12} mb={2}>
                          <SingleSelect
                            title={
                              <Typography>
                                Atribuir a usuário:
                              </Typography>
                            }
                            displayText={"nenhum - selecionar usuário"}
                            name={`userTransfer-${conn.connectionId}-${queueId}`}
                            key={`userTransfer-${conn.connectionId}-${queueId}`}
                            options={renderUserOptions(conn.connectionId, queueId)}
                            onSelected={(opt) => {
                              setSelectedConnectionsAndQueues(prev => {
                                return prev.map(item => item.connectionId == conn.connectionId && item.originQueueId == queueId ? { ...item, userId: opt } : item);
                              });
                            }}
                            selected={selectedConnectionsAndQueues.find(item => item.connectionId == conn.connectionId && item.originQueueId == queueId)?.userId || undefined}
                            disabled={selectedConnectionsAndQueues.find(item => item.connectionId == conn.connectionId && item.originQueueId == queueId)?.queueId ? false : true}
                            closeOnSelect={false}
                            toggleOnReselect={true}
                          />
                        </Grid>
                      </Grid>
                    </>
                  );
                });
              })}
            </>
            :
            i18n.t("users.disableModal.withOutConnections")
        }
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (activeStep == 0) handleClose();
            else setActiveStep((prevActiveStep) => prevActiveStep - 1);
          }}
          color="secondary"
          disabled={loading}
          variant="outlined"
        >
          {activeStep == 0 ? i18n.t("buttons.close") : i18n.t("buttons.previous")}
        </Button>
        <Button
          type="submit"
          color="primary"
          disabled={loading}
          variant="contained"
          onClick={handleSave}
        >
          {activeStep < (connections.length - 1) ? `${i18n.t("buttons.next")}` : `${i18n.t("buttons.save")}`}
          {loading && (
            <CircularProgress
              size={24}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserModal;